import React from 'react';
import './Footer.css';
import { FaEnvelope, FaMapMarkerAlt, FaGithub } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* 1. About PACA */}
        <div className="footer-column">
          <h4>About PACA</h4>
          <p className="footer-description">
            A modern, accessible solution for paleocoordinate calculation, 
            developed by researchers at the University of Barcelona.
          </p>
          <div className="footer-social">
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
          </div>
        </div>

        {/* 2. Navigation */}
        <div className="footer-column">
          <h4>Navigation</h4>
          <nav className="footer-nav">
            <a href="/paca/">Home</a>
            <a href="/paca/rotate">Rotate</a>
            <a href="/paca/citation">Citation</a>
            <a href="/paca/about">About</a>
          </nav>
        </div>

        {/* 3. Contact */}
        <div className="footer-column contact-block">
          <h4>Contact</h4>
          <div className="contact-info">
            <div className="contact-person">
              <p className="contact-name">Noa Scholz Murcia</p>
              <a href="mailto:scholz@ub.edu" className="contact-email">
                <FaEnvelope />
                scholz@ub.edu
              </a>
            </div>

            <div className="contact-institution">
              <p className="institution-name">
                <FaMapMarkerAlt className="location-icon" />
                University of Barcelona
              </p>
              <p className="institution-dept">Section of Statistics</p>
              <p className="institution-details">
                Department of Genetics, Microbiology and Statistics
              </p>
              <p className="institution-details">Faculty of Biology</p>
              <p className="institution-address">
                Av. Diagonal 643, 08028 Barcelona, Spain
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-version">
          PACA – Paleocoordinates Calculator v1.0
        </p>
        <p className="footer-copyright">
          © 2025 University of Barcelona. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
